import { OfflineProcessDataResponseResult } from "../Api/AcceptBomsResponsesModels";
import { InviteSupplierModel } from "../Supplier/Supplier";

export enum OfflineProcessType {
    CreateAndSendSurveys = "CreateAndSendSurveys",
    Report = "Report",
    CreateAndSendSupplierInviteSurveys = "CreateAndSendSupplierInviteSurveys",
    SendDraftSurvey = "SendDraftSurvey",
    ActivateSurveyMaterials = "ActivateSurveyMaterials",
    AcceptSurveyMaterials = "AcceptSurveyMaterials",
    SubmitSurveyResponse = "SubmitSurveyResponse"
}

export enum OfflineProcessingStageType {
    Queued = "Queued",
    Working = "Working",
    TotallyComplete = "TotallyComplete",
    Failed = "Failed",
    PublisingPassports = "PublishingPassports",
    SendingEmails = "SendingEmails"
}

export interface OfflineProcessState {
    processingStage: OfflineProcessingStageType;
    currentProgressItemIndex: number;
    progressTotalNumItems: number;
}

export interface BaseOfflineProcessData<TConotext, TResults> {
    operationId: string;
    operationType: OfflineProcessType;
    shouldEmailOnComplete: boolean;
    dateStartedUnix: number;
    dateLastUpdatedUnix: number;
    dateCompletedUnix: number | null;
    userIdWhoInitiatedOperation: string;
    fullNameOfUserWhoInitiatedOperation: string;

    context: TConotext;
    results: TResults | null;
    state: OfflineProcessState;
}

// ===============================================================================

//
// Create & Send Surveys
//

export interface CreateAndSendSurveysOfflineProcessContext {
    suppliersToInvite: InviteSupplierModel;
}

export interface CreateAndSendSurveysOfflineProcessResults {
    supplierIdsAndInventoryIdsTable: { [supplierId: string]: string[] };
    createdRequestIds: string[];
}

export interface CreateAndSendSurveysOfflineProcessData
    extends BaseOfflineProcessData<CreateAndSendSurveysOfflineProcessContext, CreateAndSendSurveysOfflineProcessResults> {

}

// ===============================================================================

//
// Bulk Reporting
//

export interface BulkReportingReportedFileMetadata {
    fileId: string;
    filename: string;
}


export interface BulkReportingContext {
    inventoryIdsToReport: string[];
    reportTypes: string[];
}

// ===============================================================================

export interface BulkReportingResults {
    zipFileId: string;
    processingState: string;
    reportedFiles: BulkReportingReportedFileMetadata[];
}

// ===============================================================================

//
// send normal survey
//

// context needs to be general for the different possibilities; if this is being used, context shouldn't matter.
export interface OfflineGeneralSurveyProcessData
    extends BaseOfflineProcessData<any, OfflineProcessDataResponseResult> {

}
